import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AddSampleComponent } from '../../../components/well/samples/add/add-samples.component';
import { EditSampleComponent } from '../../../components/well/samples/edit/edit-samples.component';
import { IAddSampleDataViewModel } from '../../../models/well/samples/sample.viewmodel';
import { Search } from '../../../models/well/search/search';
import { ISearchResult } from '../../../models/well/search/search.result';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { DeleteSampleComponent } from './delete/delete-samples.component';
import { SharedService } from '@shared/services/shared.service';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'list-samples',
  templateUrl: './list-samples.component.html',
  styleUrls: ['./list-samples.component.scss']
})
export class ListSamplesComponent implements AfterViewInit {
  @Input('wellId')
  wellId: number = 0;
  processing = false;
  pageSize = 10;
  resultSize: number = 0;
  modalWidth = '90%';
  searchResults: ISearchResult[] = [];

  displayedColumns: string[] = ['sampleId', 'createDate', 'collectionDate', 'retOrNot', 'qA', 'numberofSampleTests', 'hasExceedances', 'voucherId', 'highestNitrateTestResult', 'tier', 'action'];
  dataSource = new MatTableDataSource<ISearchResult>(this.searchResults);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  search: Search = {
    wellId: '',
    sampleId: '',
    contaminant: [],
    address: '',
    county: '',
    city: '',
    state: '',
    zip: '',
    wellTag: '',
    wellLog: '',
    startDate: '',
    endDate: '',
    createStartDate: '',
    createEndDate: '',
    receivedStartDate: '',
    receivedEndDate: '',
    isValidated: false,
    searchBy: 'Sample',
    searchResultsMaxRows: '5000',
    voucherType: '',
    voucherOhaId: '',
    voucherIdentifier: ''
  }


  addSampleData: IAddSampleDataViewModel = {
    wellId: 0,
    sampleId: 0
  }

  constructor(public dialog: MatDialog, public oregonWellDataService: OregonWellDataService,
    public authService: AuthService, private sharedService: SharedService) { }

  ngAfterViewInit(): void {
    this.loadSamples();
  }

  loadSamples() {
    this.processing = true;
    this.search.wellId = this.wellId.toString();
    this.oregonWellDataService.Search(this.search).subscribe(
      result => {
        this.searchResults = [];
        result.forEach( item => {
          this.searchResults.push(item.data);
        });
        this.processing = false;
        this.resultSize = result.length;
      },
      error => {
        this.processing = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<ISearchResult>(this.searchResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  addSample(sampleId: number) {
    this.addSampleData.wellId = this.wellId;
    this.addSampleData.sampleId = sampleId;
    const dialogRef = this.dialog.open(AddSampleComponent, {
      width: this.modalWidth,
      data: this.addSampleData
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadSamples();
    });
  }

  deleteSample(sampleId: number) {
    const dialogRef = this.dialog.open(DeleteSampleComponent, {
      width: this.modalWidth,
      data: sampleId
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadSamples();
    });
  }

  editSample(sampleId: number) {
    const dialogRef = this.dialog.open(EditSampleComponent, {
      width: this.modalWidth,
      data: sampleId
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadSamples();
    });
  }
}